import clsx from 'clsx'
import React, { useState } from 'react'

import SvgCheckRounded from '@Assets/SVG/CheckRounded'
import { Button } from '@Components/Button'
import { useClub } from '@Domains/Club/Hook'
import { useTranslation } from '@Globals/Translations'
import { EmailValidationV2 } from '@Shared/Components/Forms/Validations/EmailValidation'
import { NotEmptyValidationV2 } from '@Shared/Components/Forms/Validations/NotEmptyValidation'
import { TextInput, useTextInputActionRef } from '@Shared/Components/Inputs/TextInput/TextInput'

import styles from './styles.module.scss'

export const ClubSignIn = () => {
  const { defaultEmail, login, passwordResetSuccess, setModalState } = useClub()
  const { t } = useTranslation()
  const emailActionRef = useTextInputActionRef()
  const [email, setEmail] = useState(defaultEmail || '')
  const passwordActionRef = useTextInputActionRef()
  const [password, setPassword] = useState('')
  const [genericError, setGenericError] = useState<string | undefined>()

  return (
    <form onSubmit={async (e) => {
      e.preventDefault()
      e.stopPropagation()
      emailActionRef.current?.touch()
      const isEmailValid = emailActionRef.current?.validate()
      passwordActionRef.current?.touch()
      const isPasswordValid = passwordActionRef.current?.validate()
      if (isEmailValid && isPasswordValid) {
        const err = await login(email, password)
        if (err) {
          setGenericError(err)
          return
        }

        setModalState('CLOSED')
      }
    }}
    >
      {passwordResetSuccess && (
        <span className={clsx(styles.passwordReset, styles.formElementGab)}>
          <SvgCheckRounded />
          <p className={styles.smallLabel}>{t('common:TRENDHIMCLUB_PASSWORD_SAVED')}</p>
        </span>
      )}
      <p className={clsx(styles.bigLabel)}>{t('common:TRENDHIMCLUB_WELCOME_BACK')}</p>
      <p className={clsx(styles.formElementGab)}>{t('common:TRENDHIMCLUB_LOGIN_ACTIVATION')}</p>
      <TextInput
        actionRef={emailActionRef}
        autoFocus={!defaultEmail}
        className={styles.formElementGab}
        id="ClubModal_Signup_Email"
        label={t('common:EMAIL_ADDRESS')}
        onChange={(value) => {
          setGenericError(undefined)
          setEmail(value)
        }}
        validations={[EmailValidationV2]}
        value={email}
      />
      <TextInput
        actionRef={passwordActionRef}
        autoFocus={!!defaultEmail}
        className={styles.formElementGab}
        id="ClubModal_Signup_Password"
        label={t('common:PASSWORD')}
        onChange={(value) => {
          setGenericError(undefined)
          setPassword(value)
        }}
        type="password"
        validations={[NotEmptyValidationV2]}
        value={password}
      />
      <button
        className={clsx(styles.labelButton, styles.formElementGab)}
        onClick={() => setModalState('FORGOT_PASSWORD')}
        style={{ margin: '0' }}
        type="button"
      >
        {t('common:TRENDHIMCLUB_FORGOT_PASSWORD')}
      </button>
      <Button
        className={styles.nextButton}
        color="black"
        style={{ margin: '0' }}
        type="submit"
      >
        {t('common:LOGIN_LABEL')}
      </Button>
      {genericError && <p className={styles.error}>{t(genericError)}</p>}
      <button className={clsx(styles.labelButton, styles.modeSwitch)} onClick={() => setModalState('CREATE_ACCOUNT')} type="button">
        {t('common:TRENDHIMCLUB_SIGN_UP_LABEL')}
      </button>
    </form>
  )
}

